import { Link } from "react-router-dom";

export const Footer = () => {
  return (
    <footer className="bg-white border-t border-slate-200 py-12 text-center text-sm">
      <div className="container mx-auto px-4 flex flex-col items-center">
        <div className="flex flex-row items-center justify-center gap-6 sm:gap-12 mb-8">
          <Link to="/">
            <img
              src="https://vibe.filesafe.space/1775166810156919871/attachments/07b67583-88fd-417b-bb44-aeaaee1d2dda.png"
              alt="Clean Marketing Logo"
              loading="lazy"
              width="160"
              height="40"
              className="h-8 sm:h-10 opacity-80 hover:opacity-100 transition-opacity object-contain"
            />
          </Link>

          <div className="h-12 w-px bg-slate-200"></div>

          <div className="flex flex-col items-start">
            <p className="text-slate-500 font-medium mb-1 text-[10px] sm:text-xs uppercase tracking-wider">
              Official Sponsor of
            </p>
            <a
              href="https://www.theuncleanables.co.uk"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:opacity-80 transition-opacity"
            >
              <img
                src="https://vibe.filesafe.space/1775166810156919871/attachments/9f531d29-517d-40d4-8af9-b2e1fc27ebfa.webp"
                alt="The Uncleanables Podcast"
                loading="lazy"
                width="140"
                height="56"
                className="h-10 sm:h-14 object-contain"
              />
            </a>
          </div>
        </div>

        <div className="flex flex-col md:flex-row items-center justify-between w-full gap-4 pt-8 border-t border-slate-100">
          <p className="text-slate-500">
            © {new Date().getFullYear()} Clean Marketing. All rights reserved.
          </p>
          <div className="flex items-center gap-6 text-slate-500">
            <Link
              to="/privacy"
              className="hover:text-primary transition-colors"
            >
              Privacy Policy
            </Link>
            <Link to="/terms" className="hover:text-primary transition-colors">
              Terms & Conditions
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};
